import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/cms/brands/bg-77.jpg")